import { EditButton, TopToolbar, usePermissions, useTranslate } from 'react-admin'
import { Typography, Rating } from "@mui/material"
import getSubscriptionInfo from './subscriptions/getSubscriptionInfo'
import { Permissions } from '../authentication/Permissions'
import OrderSubscriptionButton from './subscriptions/OrderSubscriptionButton'
import { useEffect } from 'react'

const UserShowActions = () => {

  const translate = useTranslate()
  const {isLoading: isLoadingPermissions, permissions, refetch} = usePermissions<Permissions>()
  const subscriptionInfo = getSubscriptionInfo(permissions?.activeSubscriptions)

  useEffect(() => {
    refetch()
  }, [])

  if(isLoadingPermissions) return null

  return (
    <TopToolbar>
      <>
        <Typography>
          {`${translate('resources.users.menu.subscription')}: ${subscriptionInfo?.name}`}
        </Typography>
        <Rating sx={{pb:1}} readOnly value={subscriptionInfo?.rating} max={3} />
      </>
      <OrderSubscriptionButton />
      <EditButton />
    </TopToolbar>
  )
}

export default UserShowActions